export enum PosTableSeatValueEnum {
  SEAT = 'Seat'
}